import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import { useNavigate, useOutletContext } from 'react-router-dom';

import { PasswordInput } from '../password-input';
import { useLoginTwoVerifyMutation } from '../../auth.api';
import { clearMarketingReferralCookie } from 'utils/referral-cookie';

const defaultErrorMessage: string = 'رمز عبور باید حداقل 8 کارکتر باشد';

export function TwoStepVerifyForm(): JSX.Element {
    const navigate = useNavigate();
    const [login, { isLoading }] = useLoginTwoVerifyMutation();

    const [phone] =
        useOutletContext<
            [string, React.Dispatch<React.SetStateAction<string>>]
        >();

    const [password, setPassword] = useState<string>('');
    const [isFirstTime, setIsFirstTime] = useState<boolean>(true);
    const [serverError, setServerError] = useState<string | undefined>(
        undefined,
    );

    const passwordError =
        serverError ??
        (!isFirstTime && password.length < 8 ? defaultErrorMessage : undefined);

    useEffect(() => {
        if (!phone) navigate('/');
    }, [navigate, phone]);

    const handleSubmit = async () => {
        isFirstTime && setIsFirstTime(false);

        if (password?.length >= 8) {
            setServerError(undefined);
            try {
                const result = await login({
                    password: password,
                    phone: phone ? phone : '',
                }).unwrap();

                if (result?.token) {
                    clearMarketingReferralCookie();
                    localStorage.setItem('token', result.token);
                    window.location.href = '/register';
                }
            } catch (error: any) {
                const errorMessage = error?.data?.errors?.password?.[0];
                setServerError(errorMessage);
            }
        }
    };

    function handleChangePassword(event: {
        target: { name: string; value: string };
    }) {
        const value = event.target.value.replaceAll(' ', '');

        setPassword(value);
    }

    return (
        <>
            <Typography
                sx={{
                    color: 'text.primary',
                    marginTop: 1,
                    marginBottom: 1,
                    fontSize: { xs: '18px', sm: '20px' },
                }}
                className="font-yekan-heavy"
                variant="h3"
                component="h1"
            >
                ورود دو مرحله ای
            </Typography>

            <Typography
                component="h4"
                sx={{ marginBottom: 3, fontSize: { xs: '13px', sm: '14px' } }}
                className="font-sans"
            >
                لطفا رمز عبور حساب کاربری خود را وارد کنید.
            </Typography>

            <PasswordInput
                onChange={handleChangePassword}
                onSubmit={handleSubmit}
                value={password}
                error={passwordError}
                label="رمز عبور"
            />

            <LoadingButton
                loading={isLoading}
                sx={{ marginTop: 4 }}
                onClick={handleSubmit}
                onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
                disabled={!isFirstTime && password?.length < 8}
                variant="contained"
                className="font-sans"
            >
                تایید و ادامه
            </LoadingButton>
        </>
    );
}
